// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"d16de656","163":"ee9cd15a","190":"e82ab34d","421":"83ee2148","524":"5329f13c","561":"079b3926","857":"331f19cd"}[chunkId] + ".chunk.js";
};